<template>
  <div class="video-container">
    <video 
      ref="videoPlayer" 
      class="video-player" 
      autoplay 
      muted 
      :loop="!imagenLista" 
      @ended="verificarYRedirigir"
      :src="videoSrc">
      Tu navegador no soporta videos.
    </video>

    <!-- Indicador de estado -->
    <div class="status-indicator">
      <span class="status-text">{{ estadoLabel }}</span>
      <span class="status-dot" :class="estadoProcesamiento"></span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { openDB } from "idb";

export default {
  data() {
    return {
      clavePendiente: null,
      imagenLista: false,
      chequeoIntervalo: null,
      redirectTimeout: null,
      videoSrc: "",
      db: null,
      estadoProcesamiento: "idle", // 'idle' | 'processing' | 'done'
    };
  },
  computed: {
    estadoLabel() {
      switch (this.estadoProcesamiento) {
        case "processing":
          return "Procesando imagen…";
        case "done":
          return "Imagen lista";
        default:
          return "En espera";
      }
    },
  },
  async created() {
    this.obtenerClavePendiente();
    await this.initDB();
    await this.cargarVideoDesdeIndexedDB();
    this.iniciarChequeoImagen();
  },
  beforeUnmount() {
    if (this.chequeoIntervalo) clearInterval(this.chequeoIntervalo);
    if (this.redirectTimeout) clearTimeout(this.redirectTimeout);
  },
  methods: {
    async initDB() {
      this.db = await openDB("videoDB", 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains("videos")) {
            db.createObjectStore("videos");
          }
        },
      });
    },
    async cargarVideoDesdeIndexedDB() {
      try {
        const cachedVideo = await this.db.get("videos", "video.mp4");

        if (cachedVideo) {
          this.videoSrc = URL.createObjectURL(cachedVideo);
        } else {
          const response = await fetch(require("@/assets/video.mp4"));
          const blob = await response.blob();
          await this.db.put("videos", blob, "video.mp4");
          this.videoSrc = URL.createObjectURL(blob);
        }
      } catch (error) {
        console.error("Error al manejar el video en IndexedDB:", error);
      }
    },
    obtenerClavePendiente() {
      this.clavePendiente = this.$store.state.tokens.clavePendiente;
      if (!this.clavePendiente) {
        console.error("Clave pendiente no encontrada en el store");
      }
    },
    iniciarChequeoImagen() {
      const tokenFinal = this.$store.state.tokens.tokenFinal;
      if (!tokenFinal) {
        console.error("token_final no encontrado");
        return;
      }

      this.estadoProcesamiento = "idle";

      this.chequeoIntervalo = setInterval(async () => {
        try {
          const response = await axios.post("/api/estado-imagen", {
            token_final: tokenFinal,
          });

          const procesada = response.data?.procesada === "1";
          const procesando = response.data?.procesando === "1";

          if (!procesada && !procesando) {
            this.estadoProcesamiento = "idle";
            return;
          }

          if (!procesada && procesando) {
            this.estadoProcesamiento = "processing";
            return;
          }

          if (procesada && procesando) {
            if (this.estadoProcesamiento === "done") return;

            this.estadoProcesamiento = "done";
            this.imagenLista = true;

            const rutaFinal = `${tokenFinal}.png`;
            localStorage.setItem("processedImageName", rutaFinal);
            console.log("✅ Imagen lista:", rutaFinal);

            if (this.chequeoIntervalo) {
              clearInterval(this.chequeoIntervalo);
              this.chequeoIntervalo = null;
            }

            this.$nextTick(() => {
              if (this.$refs.videoPlayer) {
                this.$refs.videoPlayer.loop = false;
              }
            });

            if (this.redirectTimeout) {
              clearTimeout(this.redirectTimeout);
            }
            this.redirectTimeout = setTimeout(() => {
              this.$router.push("/ver-qr");
            }, 2000);
          }
        } catch (error) {
          console.error("Error al consultar imagen procesada:", error);
        }
      }, 5000);
    },
    verificarYRedirigir() {
      if (this.imagenLista) {
        this.$router.push("/ver-qr");
      }
    },
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
  overflow: hidden;
}

.video-player {
  width: 100%;
  height: auto;
}

/* Indicador de estado */
.status-indicator {
  position: fixed;          /* siempre visible encima del video */
  top: 1.25rem;
  right: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  z-index: 9999;

  /* Pastilla semi-transparente para que se lea bien sobre fondo claro */
  padding: 0.25rem 0.6rem;
  border-radius: 9999px;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
}

.status-dot {
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
}

/* 0,0 -> gris fijo */
.status-dot.idle {
  background-color: #9ca3af;
}

/* 0,1 -> amarillo parpadeando */
.status-dot.processing {
  background-color: #facc15;
  animation: blink 1.2s ease-in-out infinite;
}

/* 1,1 -> verde fijo */
.status-dot.done {
  background-color: #22c55e;
}

.status-text {
  color: #f9fafb; /* casi blanco */
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;  /* para que no salte de línea */
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.9); /* sombrita para que se lea siempre */
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
</style>
